import { Store } from "pullstate";
import api from "$services/api";
import logger from "$services/logger";

const initialState = {
    pg: [],
    sector: [],
    periodYear: null,
    periodMonth: null,
    isLoading: true,
};

export const FoleySignalsStore = new Store(initialState);

export const resetFoleySignals = () => {
    FoleySignalsStore.update(() => ({ ...initialState }));
};

const apiFoleySignals = async (clientGroupId, apiSettings) => {
    try {
        const response = await api.get(`/api/clients/${clientGroupId}/foley-signals`, null, apiSettings);
        FoleySignalsStore.update((s) => {
            s.pg = response?.pg || [];
            s.sector = response?.sector || [];
            s.periodYear = response?.periodYear || null;
            s.periodMonth = response?.periodMonth || null;
            s.isLoading = false;
        });
    } catch (e) {
        if (api.requestWasCanceled(e)) return;
        // Non-critical: page can still render without Foley signals
        logger.error(`Unable to fetch foley signals for client ${clientGroupId}`, e);
        FoleySignalsStore.update((s) => {
            s.isLoading = false;
        });
    }
};

export const fetchFoleySignals = (clientGroupId) => {
    const abortController = new AbortController();
    apiFoleySignals(clientGroupId, { signal: abortController.signal });
    return abortController;
};
